<template>
  <el-dropdown @command="handleLanguageChange">
    <span class="language-switcher">
      <el-icon><Setting /></el-icon>
      {{ currentLanguage === 'zh' ? '简体中文' : currentLanguage === 'en' ? 'English' : 'Tiếng Việt' }}
      <el-icon class="el-icon--right"><ArrowDown /></el-icon>
    </span>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item command="zh">简体中文</el-dropdown-item>
        <el-dropdown-item command="en">English</el-dropdown-item>
        <el-dropdown-item command="vi">Tiếng Việt</el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { Setting, ArrowDown } from '@element-plus/icons-vue'
import { writePortalLocale } from '@/apps/portal/i18n/locale'

const { locale } = useI18n()
const currentLanguage = computed(() => locale.value)

const handleLanguageChange = (lang) => {
  locale.value = lang
  writePortalLocale(lang)
}
</script>

<style scoped>
.language-switcher {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #ffffff;
  font-size: 14px;
  padding: 8px 12px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.language-switcher:hover {
  background-color: #3b3b3b;
}
:deep(.el-dropdown-menu__item:hover) {
  color: #00c1cd !important;
}
.el-icon {
  margin-right: 4px;
}
.el-icon--right {
  margin-right: 0;
  margin-left: 4px;
}
</style>
